import {
  MdWorkOutline,
  MdCalendarToday,
  MdTranslate,
  MdMedicalServices,
  MdSchool,
  MdVideoLibrary,
  MdCollections,
  MdMenuBook,
  MdArticle,
  MdWorkspacePremium,
  MdPayments,
  MdBadge,
  MdPhone,
  MdEmail,
  MdLocationOn,
  MdPictureAsPdf,
  MdDownload,
  MdOpenInNew,
} from "react-icons/md";
import {
  FaGlobe,
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaFacebookF,
} from "react-icons/fa";

const DmCard = ({ title, icon: Icon, children, className = "" }) => (
  <div className={`dm-card ${className}`}>
    {title && (
      <h3 className="dm-card-title">
        {Icon && <Icon />}
        {title}
      </h3>
    )}
    {children}
  </div>
);

const DmInfoRow = ({ label, value }) => (
  <div className="dm-info-row">
    <span className="dm-info-label">{label}</span>
    <span className="dm-info-value">{value}</span>
  </div>
);

const DoctorProfileView = ({ doctor }) => {
  if (!doctor) return null;

  const initials = doctor.name.replace(/Dr\.\s*/i, "").charAt(0) || "D";

  return (
    <div className="dm-page">
      <div className="dm-hero">
        <div className="dm-avatar">
          {doctor.avatar ? (
            <img src={doctor.avatar} alt={doctor.name} className="dm-avatar-img" />
          ) : (
            <span>{initials}</span>
          )}
        </div>
        <div className="dm-hero-content">
          <span className="dm-hero-prefix">{doctor.prefix}</span>
          <h1 className="dm-hero-name">{doctor.name}</h1>
          <p className="dm-hero-specialty">{doctor.specialty}</p>
          <p className="dm-hero-sub">{doctor.subtitle}</p>
          <div className="dm-badges">
            <span className="dm-badge">
              <MdWorkOutline size={14} /> {doctor.experience}
            </span>
            <span className="dm-badge">
              <MdCalendarToday size={14} /> Consult {doctor.consultFee}
            </span>
            <span className="dm-badge">
              <MdTranslate size={14} /> {doctor.language}
            </span>
          </div>
        </div>
      </div>

      <div className="dm-content-grid">
        <div className="dm-main">
          <DmCard title="About" icon={MdMedicalServices}>
            <p className="dm-text">{doctor.about}</p>
          </DmCard>

          <DmCard title="Qualifications" icon={MdSchool}>
            <div className="dm-tags">
              {doctor.qualifications.map((q) => (
                <span key={q} className="dm-tag">{q}</span>
              ))}
            </div>
          </DmCard>

          <DmCard title="Introduction" icon={MdVideoLibrary}>
            <div className="dm-video-wrap">
              {doctor.introductionVideo ? (
                <video controls className="dm-video" src={doctor.introductionVideo}>
                  <track kind="captions" />
                </video>
              ) : (
                <div className="dm-gallery-item dm-gallery-item--placeholder">
                  <MdVideoLibrary size={36} color="#0f66a4" />
                </div>
              )}
            </div>
          </DmCard>

          <DmCard title="Gallery" icon={MdCollections}>
            <div className="dm-gallery">
              <div className="dm-gallery-item dm-gallery-item--placeholder">
                <MdCollections size={36} color="#0f66a4" />
              </div>
            </div>
          </DmCard>

          <DmCard title="Publications" icon={MdMenuBook}>
            <div className="dm-quote">
              <span className="dm-quote-bar" />
              <p>{doctor.publications}</p>
            </div>
          </DmCard>

          <DmCard title="In the News" icon={MdArticle}>
            <div className="dm-news-bar">{doctor.news}</div>
          </DmCard>

          <DmCard title="Awards" icon={MdWorkspacePremium}>
            <div className="dm-awards">
              {doctor.awards.map((award) => (
                <span key={award} className="dm-award-pill">
                  <MdWorkspacePremium size={14} /> {award}
                </span>
              ))}
            </div>
          </DmCard>
        </div>

        <aside className="dm-sidebar dm-sidebar--sticky">
          <DmCard title="Fees" icon={MdPayments}>
            <DmInfoRow label="Consultation" value={doctor.fees.consultation} />
            <DmInfoRow label="Follow-up" value={doctor.fees.followUp} />
          </DmCard>

          <DmCard title="Registration" icon={MdBadge}>
            <DmInfoRow label="Council" value={doctor.registration.council} />
            <DmInfoRow label="Number" value={doctor.registration.number} />
          </DmCard>

          <DmCard title="Contact" icon={MdPhone}>
            <div className="dm-contact-list">
              <div className="dm-contact-item">
                <MdPhone />
                <span>{doctor.contact.phone}</span>
              </div>
              <div className="dm-contact-item">
                <MdEmail />
                <span>{doctor.contact.email}</span>
              </div>
              <div className="dm-contact-item">
                <MdLocationOn />
                <span>{doctor.contact.address}</span>
              </div>
            </div>
          </DmCard>

          <button type="button" className="dm-cv-btn">
            <MdPictureAsPdf />
            <span>Download CV</span>
            <MdDownload />
          </button>

          <DmCard title="Connect">
            <div className="dm-connect-grid">
              {doctor.connect.map(({ key, label, icon: Icon, url }) => (
                <a key={key} href={url} className="dm-connect-btn" target="_blank" rel="noopener noreferrer">
                  <Icon />
                  <span>{label}</span>
                  <MdOpenInNew className="dm-connect-ext" />
                </a>
              ))}
            </div>
          </DmCard>
        </aside>
      </div>
    </div>
  );
};

export default DoctorProfileView;
